
if( $('.section--homepage-hero').length > 0 ) {

	// SET INDUSTRY CONTENT ON HOMEPAGE
	if( user_data.industry ) {
		set_homepage_industry( user_data.industry );
	}

	$(document).on('mouseenter', '.nav-industry [data-set-industry]', function(){
		industry_hover = JSON.parse($(this).attr('data-set-industry'));
		$('.homepage-hero-industry-wrapper').removeClass('active').filter('[data-industry="' + industry_hover.id + '"]').addClass('active');
		$('.homepage-hero-industry-wrapper').find('.lazy-load').each(function(){
			lazy_reflow( parseInt( $(this).attr('data-lazy-key') ) );
		});
		$('.nav-industry-header-icons-icon img').attr('src', industry_hover.icon);
	}).on('mouseleave', '.nav-industry [data-set-industry]', function(){
		$('.homepage-hero-industry-wrapper').removeClass('active').filter('[data-industry="' + homepage_video_default + '"]').addClass('active');
		$('.homepage-hero-industry-wrapper').find('.lazy-load').each(function(){
			lazy_reflow( parseInt( $(this).attr('data-lazy-key') ) );
		});
		if( user_data.industry ) {
			$('.nav-industry-header-icons-icon img').attr('src', user_data.industry.icon);
		} else {
			$('.nav-industry-header-icons-icon img').attr('src', '/wp-content/themes/theleeco/library/images/icon-no-industry-selected.svg');
		}
	})
}
